import { RenewalTableItem } from "../../utils/quoteUtils";
import { useUpdateRenewal } from "./useUpdateRenewal";
import { useState } from "react";
import { DMConfirmModal } from "../../../shared/DMModal/DMConfirmModal";
import { useDataTable } from "../DataTable/DataTableContext";
import { unreachableCase } from "../../../utils";

function getDisabledReason(
  reason: Required<RenewalTableItem>["disabledReasons"][number]
): string {
  switch (reason) {
    case "8-12":
      return "8-12 district";
    case "manual":
      return "Manually disabled";
    case "sendCustomerEmailFlag":
      return "Needs additional info or further investigation";
    case "ncesFlag":
      return "NCES is flagged";
    case "individualSiteNotDefined":
      return "Individual SNN with no site id";
    default:
      return unreachableCase(reason);
  }
}

export const RenewalDisabledCell: React.FC<{
  value: boolean;
  renewal: RenewalTableItem;
}> = ({ value, renewal }) => {
  const { canEnableRenewals } = useDataTable<{ canEnableRenewals: boolean }>();
  const updateRenewal = useUpdateRenewal();

  const [showConfirm, setShowConfirm] = useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    if (checked) {
      updateRenewal(renewal._id, { disabled: true });
    } else {
      setShowConfirm(true);
    }
  };

  return (
    <>
      <input
        key={`disabled-${renewal._id}`}
        type="checkbox"
        checked={value}
        disabled={!canEnableRenewals}
        title={
          !canEnableRenewals
            ? "You do not have permission enable and disable renewals"
            : ""
        }
        className="disabled:cursor-not-allowed disabled:opacity-50"
        onChange={handleChange}
      />
      <DMConfirmModal
        onConfirm={() => {
          updateRenewal(renewal._id, { disabled: false });
          setShowConfirm(false);
        }}
        onCancel={() => setShowConfirm(false)}
        visible={showConfirm}
        title="Enable this renewal?"
        cancelText="Cancel"
        confirmText="Enable"
      >
        <>
          <p>This renewal has been disabled for the following reasons:</p>
          <ul className="list-disc pl-6">
            {renewal.disabledReasons && renewal.disabledReasons.length > 0 ? (
              renewal.disabledReasons.map((reason) => (
                <li key={reason}>
                  {getDisabledReason(reason)}
                  {reason === "sendCustomerEmailFlag" &&
                    renewal.sendCustomerEmailFlagReasons &&
                    renewal.sendCustomerEmailFlagReasons.length > 0 && (
                      <ul className="list-disc pl-6">
                        {renewal.sendCustomerEmailFlagReasons.map(
                          (subReason) => (
                            <li key={subReason}>{subReason}</li>
                          )
                        )}
                      </ul>
                    )}
                </li>
              ))
            ) : (
              <li>No reasons provided</li>
            )}
          </ul>
        </>
      </DMConfirmModal>
    </>
  );
};
